import React, { useContext, useEffect, useState } from 'react';
import { FormContext } from '../Form';
import Input from '../Input';
import Row from '../../layout/Row';
import { dec2Hex, hex2Dec } from '../../utility/functions';
import useDebounce from '../../utility/debounce';
import Button from '../Button';

const ColorInput = ({ ...props }) => {
    const context = useContext(FormContext);
    const propName = props.name || 'logoColor';
    const [state, setState] = useState(dec2Hex(context.values[propName] || 0));
    const debouncedValue = useDebounce(state, props.debounce || 100);

    useEffect(() => {
        const resolveColor = (value) => {
            if (isNaN(value)) {
                return hex2Dec(value.replace('#', ''));
            }
            return value;
        };
        context.setValue(propName, resolveColor(debouncedValue))
    }, [debouncedValue])

    const toDisable = context ? context.submitting || context.editing || props.disable : props.disable

    return (
        <Row>
            <Input
                label='Color'
                value={dec2Hex(context.values[propName] || 0)}
                name='hexColor'
                type='color'
                style={{ width: '5em', height: '3em' }}
                onInput={e => {
                    const color = e.target.value.replace('#', '');
                    setState(hex2Dec(color))
                }}
                flex='0'
                disabled={toDisable}
                standalone
            />
            <Input
                name={propName}
                type='hidden'
                flex='0'
                {...props}
            />
            {context.values[propName] && !props.required ? (
                <Button
                    label='Remove Color'
                    onClick={() => context.setValue(propName, '')}
                    disabled={toDisable}
                />
            ) : null}
        </Row>
    )
}

export default ColorInput;
